import { Stack } from '@mantine/core';
import classes from './BaseMapOption.module.css';

type BaseMapType = 'base' | 'satellite' | 'labels';

const BASE_MAP_TYPES: Record<
  BaseMapType,
  {
    name: string;
    imgSrc: string;
    value: string;
  }
> = {
  base: { name: 'Map', imgSrc: '/icons/light.png', value: 'base' },
  satellite: {
    name: 'Satellite',
    imgSrc: '/icons/satellite.png',
    value: 'satellite',
  },
  labels: {
    name: 'Map - No labels',
    imgSrc: '/icons/light.png',
    value: 'labels',
  },
};

interface Props {
  option: BaseMapType;
  selected: string;
  onChange: (value: string) => void;
}
export const BaseMapOption = ({ option, ...props }: Props) => {
  const { name, imgSrc, value } = BASE_MAP_TYPES[option];
  const isSelected = value === props.selected;

  return (
    <Stack
      align="center"
      gap="xxs"
      fz="xs"
      lh="xs"
      className={`${classes.wrapper} ${isSelected ? classes.wrapperSelected : ''}`}
      onClick={() => props.onChange(value)}
      data-testid={`base-map-option-${value}`}
      data-selected={isSelected}
    >
      <img
        className={`${classes.thumbnail} ${isSelected ? classes.thumbnailSelected : ''}`}
        src={imgSrc}
        alt={name}
      />
      {name}
    </Stack>
  );
};
